import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { ICompanyMSNote } from '~/types/note/models'

export const {
  getNoteListData: getCompanyMSNoteListData,
  getNoteDataById: getCompanyMSNoteDataById,
  getNoteListDataByParentId: getCompanyMSNoteListDataByCMSId,
} = makeNoteMockData<ICompanyMSNote>({
  entityName: 'companyMasterService',
  storageKeyPrefix: 'companyms',
})
